export const missionEn = {
    title: 'ภารกิจของคุณ',
    detail:{
        coupon4: {
            title: 'สะสมครบ 4 ครั้ง',
            btn: 'สะสมเพิ่ม',
            btn_success: 'สะสมครบแล้ว',
        },
        coupon6: {
            title: 'สะสมครบ 6 ครั้ง',
            btn: 'สะสมเพิ่ม',
            btn_success: 'สะสมครบแล้ว',
        },
        checkin: { 
            title: 'ทาครีมทุกวัน',
            btn: 'คลิกเพื่อทาครีม',
            desc: 'ทาครีมไปแล้ว',
            btn_next_day: 'ทำภารกิจต่อไปในวันพรุ่งนี้',
        },
        review: {
            title: 'เลือกผลิตภัณฑ์ที่จะรีวิว',
            get: 'รับ',
            btn_review: 'รีวิว',
        },
        success_checkin: {
            success_one_header: 'ยินดีด้วยคุณทำภารกิจสำเร็จ',
            success_one_desc: 'คุณสามารถทำภารกิจครั้งต่อไป<br/>ได้ในวันพรุ่งนี้',

            day7mission: "จากการทาครีมสำเร็จครบทั้ง 7 วัน", 
            do_mission_next_day: "คุณสามารถเริ่มเล่นกิจกรรมใหม่ได้<br/>อีกครั้งในวันพรุ่งนี้",
            other_mission: "ดูภารกิจอื่นๆ",
        },
        update_profile: {
            title: 'อัพเดทโปรไฟล์',
            text_get: 'รับพอยท์',
            text_fill: 'เพียงกรอกข้อมูลส่วนตัวให้ครบถ้วน',
            btn_submit: 'บันทึก',
            form: {
                title: {
                    label: 'คำนำหน้าชื่อ',
                    required: 'กรุณาเลือกคำนำหน้าชื่อ',
                    mr:{
                        label:'นาย',
                        placeholder: '',
                        required: '',
                        too_short: '',
                        invalid: '',
                    },
                    mrs: {
                        label:'นาง',
                        placeholder: '',
                        required: '',
                        too_short: '',
                        invalid: '',
                    },
                    miss: {
                        label:'นางสาว',
                        placeholder: '',
                        required: '',
                        too_short: '',
                        invalid: '',
                    }
                },
                gender: {
                    label: 'เพศ',
                    required: 'กรุณาเลือกเพศ',
                    male: {
                        label:'ชาย',
                        placeholder: '',
                        required: '',
                        too_short: '',
                        invalid: '',
                    },
                    female: {
                        label:'หญิง',
                        placeholder: '',
                        required: '',
                        too_short: '',
                        invalid: '',
                    },
                    other: {
                        label:'อื่นๆ',
                        placeholder: '',
                        required: '',
                        too_short: '',
                        invalid: '',
                    }
                },
                firstname: {
                    name: 'ชื่อ',
                    placeholder: 'กรอกชื่อ',
                    required: 'กรุณากรอกชื่อ',
                    too_short: '',
                    invalid: ''
                },
                lastname: {
                    name: 'นามสกุล',
                    placeholder: 'กรอกนามสกุล',
                    required: 'กรุณากรอกนามสกุล',
                    too_short: '',
                    invalid: ''
                },
        
                birthdate: {
                    name: 'วันเกิด',
                    placeholder: '',
                    required: 'กรุณาเลือกวันเกิด',
                    too_short: '',
                    invalid: 'รูปแบบวันเกิดไม่ถูกต้อง',
                    date: {
                        name: '',
                        defaultText: 'วัน',
                        required: 'กรุณาเลือกวันเกิด'
                    },
                    month: {
                        name: '',
                        defaultText: 'เดือน',
                        required: 'กรุณาเลือกวันเกิด'
                    },
                    year: {
                        name: '',
                        defaultText: 'ปี',
                        required: 'กรุณาเลือกวันเกิด'
                    },
                },
        
                contactnumber: {
                    name: 'เบอร์โทรศัพท์',
                    placeholder: 'กรอกเบอร์โทรศัพท์',
                    required: '',
                    too_short: '',
                    invalid: '',
                },
                email: {
                    name: 'อีเมล',
                    placeholder: 'กรอกอีเมล',
                    required: 'กรุณากรอกอีเมล',
                    too_short: '',
                    invalid: 'อีเมลไม่ถูกต้อง',
                },
        
                shipping: {
                    address: {
                        name: 'ที่อยู่',
                        placeholder: 'กรอกที่อยู่',
                        required: 'กรุณากรอกที่อยู่',
                        too_short: '',
                        invalid: '',
                    },
                    zipcode: {
                        name: 'รหัสไปรษณีย์',
                        placeholder: 'รหัสไปรษณีย์',
                        required: 'กรุณากรอกรหัสไปรษณีย์',
                        too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
                        invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
                    },
                    subdistrict: {
                        name: 'แขวง/ตำบล',
                        placeholder: 'เลือกแขวง/ตำบล',
                        required: 'กรุณาเลือกแขวง/ตำบล',
                        too_short: '',
                        invalid: '',
                    },
                    district: {
                        name: 'เขต/อำเภอ',
                        placeholder: 'เลือกเขต/อำเภอ',
                        required: 'กรุณาเลือกเขต/อำเภอ',
                        too_short: '',
                        invalid: '',
                    },
                    province: {
                        name: 'จังหวัด',
                        placeholder: 'เลือกจังหวัด',
                        required: 'กรุณาเลือกจังหวัด',
                        too_short: '',
                        invalid: '',
                    },
                }
            },
            success: {
                text_success: 'คุณได้ทำภารกิจสำเร็จแล้ว',
                text_get: 'คุณได้รับพอยท์',
                btn_confirm: 'ทำภารกิจต่อ',
                btn_more: 'ดูประวัติการสะสมพอยท์',
            },
            modal_back: {
                title: 'ยกเลิกการกรอกข้อมูล',
                message: 'เมื่อยกเลิกแล้วข้อมูลที่กรอก<br>จะไม่ถูกบันทึกเข้าระบบ',
                btn_confirm: 'ยืนยัน',
                btn_back: 'กลับไปกรอกข้อมูล',
            }
        },
        get_friend: {
            title: 'ชวนเพื่อนสมัครสมาชิก NAOS<br>Club',
            text_get: 'รับพอยท์ฟรี!',
            text_invite: 'เมื่อเพื่อนสมัครสมาชิกสำเร็จ 1 ท่าน',
            text_max_invite: 'สามารถชวนเพื่อนได้สูงสุดถึง 4 ท่าน',
            text_collect: 'สะสมไปแล้ว',
            btn_line: 'ชวนเพื่อนผ่านไลน์',
        },
        survey: {
            title: 'เลือกแบบสอบถาม',
            get: 'รับ',
        },
    },
    get: 'รับ',
}